import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "layout__wrapper" }
const _hoisted_2 = { class: "article-categories" }
const _hoisted_3 = { class: "docs-listing docs-listing--articles" }

import { onBeforeMount, ref } from 'vue'
import type { Raw } from 'vue'
import { useWait } from '@/app/composables/useWait'

import Layout from '@/app/components/Layout.vue'
import HeaderRoot from '@/app/components/header/Root.vue'

import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'
import { ArticlesView } from '@/models/doc.article'
import CategoriesSelection from '@/app/components/listing/categories/CategoriesSelection.vue'
import ListDocs from '@/app/components/listing/ListDocs.vue'
import LoadingError from '@/components/ui/LoadingError.vue'
import { DocsTagsView } from '@/models/docs.tags'
import { ListView } from '@/models/docs.list'


export default /*@__PURE__*/_defineComponent({
  __name: 'Articles',
  setup(__props) {

const wait = useWait()

const articlesView = ref<Raw<ListView> | null>(null)
const tagsView = ref<Raw<DocsTagsView> | null>(null)

onBeforeMount(async () => {
  await loadArticles()
})

async function loadArticles(): Promise<void> {
  wait.start('Loading Articles')
  try {
    const docsUserDataPromise = backend.getDocsUserData()
    const articlesData = await backend.getArticles()

    const articles = await ArticlesView.createView(
      articlesData,
      undefined,
      true,
    )
    articlesView.value = new ListView('All Articles', articles)

    tagsView.value = new DocsTagsView(articlesData.tags, 'articles')
    wait.end('Loading Articles')

    // We deliberately set the user data _after_ ending the loading screen
    // because the user data is not essential for this page.
    articlesView.value.setUserData(docsUserDataPromise)
  } catch (error: any) {
    wait.start('Error Loading Articles')
    Sentry.captureException(error)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_wait = _resolveComponent("v-wait")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!

  return (_openBlock(), _createBlock(Layout, { class: "layout--basic" }, {
    default: _withCtx(() => [
      _createVNode(HeaderRoot, {
        title: "Articles",
        hasDocSort: true
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_wait, { for: "Error Loading Articles" }, {
          waiting: _withCtx(() => [
            _createVNode(LoadingError)
          ]),
          _: 1
        }),
        _createVNode(_component_v_wait, {
          class: "layout__wrapper-inner layout__wrapper-inner--small-gap container",
          for: "Loading Articles"
        }, {
          waiting: _withCtx(() => [
            _createVNode(_component_loading_spinner)
          ]),
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_2, [
              (tagsView.value?.hasTags)
                ? (_openBlock(), _createBlock(CategoriesSelection, {
                    key: 0,
                    view: tagsView.value
                  }, null, 8, ["view"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("section", _hoisted_3, [
              (articlesView.value)
                ? (_openBlock(), _createBlock(ListDocs, {
                    key: 0,
                    view: articlesView.value
                  }, null, 8, ["view"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})